<template>
  <div class="eds-comp-task-info" @click="showTask(taskInfo)">
    <div>
      <v-icon :color="taskIconColor" style="height: 30px; vertical-align: middle; margin-right: 5px">{{ taskIcon
      }}</v-icon>
      <span style="font-weight: bold">{{ taskInfo.flowName }}</span>
      <span style="font-weight: bold" v-if="isDev">({{ taskInfo.id + $t('测试') }})</span>
    </div>
    <div class="task_content_main">
      <div class="eds_content2">
        <span class="eds_content_prop">{{ $t('申请标题') }}</span>
        <span class="eds_content_value">{{ taskInfo.flowTitle }}</span>
      </div>
      <div class="eds_content2">
        <span class="eds_content_prop">{{ $t('申请描述') }}</span>
        <span class="eds_content_value">{{ taskInfo.flowDesc }}</span>
      </div>
      <v-divider></v-divider>
      <div class="eds_content_footer">
        <span class="eds-content__time">{{ createDate }}</span>
        <span :class="waitingTimeClass" class="eds-content__waiting-time">{{ waitingTime }}</span>
        <div class="eds_content_btns">
          <template v-if="taskInfo.state == 'awaiting'">
            <v-btn small flat color="primary" @click="(e) => { reject(e) }">{{ $t('拒绝') }}</v-btn>
            <v-btn small flat color="primary" @click="(e) => { approve(e) }">{{ $t('同意') }}</v-btn>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import msgbus from '../msgBus'
import devHelper from '../util/devHelper'
import debugHelper from '../util/debug'
import dbHelper from '../util/db'
import dateHelper from '../util/date'
import { TASK_STATE } from '../config/work'

export default {
  name: 'eDSCompTaskInfo',
  props: {
    taskInfo: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {}
  },
  computed: {
    isDev() {
      return devHelper.isDevMode() // 判断是否开启了测试模式
    },

    taskIcon() {
      return this.taskInfo ? TASK_STATE[this.taskInfo.state].icon : ''
    },
    taskIconColor() {
      return this.taskInfo ? TASK_STATE[this.taskInfo.state].color : ''
    },
    createDate() {
      if (this.waitingTime) {
        return dateHelper.timestamp2LocalDate(this.taskInfo.createTime)
      }
      return dateHelper.timestamp2LocalTime(this.taskInfo.createTime)
    },
    waitingTime() {
      if (this.taskInfo.state === 'approved') {
        return this.$t('已同意')
      } else if (this.taskInfo.state === 'rejected') {
        return this.$t('已拒绝')
      }
      const wait = dateHelper.unixFromNow(this.taskInfo.createTime, null, 'minute')
      return wait
    },
    waitingTimeClass() {
      const classes = []
      if (this.taskInfo.state === 'approved' || this.taskInfo.state === 'rejected') {
        classes.push('dl-gray')
      } else {
        const fromVal = this.taskInfo.createTime - Math.floor(Date.now() / 1000)
        if (fromVal > -21600) {
          classes.push('dl-gray')
        } else if (fromVal > -86400) {
          classes.push('dl-orange')
        } else {
          classes.push('dl-red')
        }
      }
      return classes.join(' ')
    }
  },
  methods: {
    // 显示任务详情
    showTask(task) {
      var scroll = document.getElementsByClassName('scroll-container')[0]
      debugHelper.log('存储scrollTop : ' + scroll.scrollTop)
      dbHelper.set('taskListScrollTop', scroll.scrollTop)
      dbHelper.set('taskListRecordCount', msgbus.vm.getTaskListRecordCount())

      let routerName = msgbus.vm.isEDS16() ? 'flowinfo16' : 'flowinfo'
      this.$router.push({
        name: routerName,
        params: {
          flowID: this.taskInfo.flowID,
          flowTid: msgbus.vm.getCurrentTenantID(),
        },
      })
    },
    // 拒绝
    reject(e) {
      e.stopPropagation()

      var scroll = document.getElementsByClassName('scroll-container')[0]
      debugHelper.log('存储scrollTop : ' + scroll.scrollTop)
      dbHelper.set('taskListScrollTop', scroll.scrollTop)
      dbHelper.set('taskListRecordCount', msgbus.vm.getTaskListRecordCount())

      this.$router.push({
        name: 'taskrefuse',
        params: {
          taskInfo: this.taskInfo,
          taskTid: msgbus.vm.getCurrentTenantID(),
        },
      })
    },
    // 同意
    approve(e) {
      e.stopPropagation()

      var scroll = document.getElementsByClassName('scroll-container')[0]
      debugHelper.log('存储scrollTop : ' + scroll.scrollTop)
      dbHelper.set('taskListScrollTop', scroll.scrollTop)
      dbHelper.set('taskListRecordCount', msgbus.vm.getTaskListRecordCount())

      this.$router.push({
        name: 'taskagree',
        params: {
          taskInfo: this.taskInfo,
          taskTid: msgbus.vm.getCurrentTenantID(),
        },
      })
    },
  },
  created() {
    console.log('调试代码')
  },
  mounted() { },
}
</script>


<style lang="scss">
.eds-comp-task-info {
  .task_content_main {
    margin-top: 10px;
    margin-left: 30px;

    &>.eds_content2 {
      margin-right: 20px;
    }

    & .eds_content_footer {
      position: relative;

      &>.eds-content__time {
        color: rgba(138, 138, 138, 1);
        line-height: 28px;
      }

      &>.eds-content__waiting-time {
        margin-left: 20px;
        color: rgba(138, 138, 138, 1);
        line-height: 28px;
      }

      .eds_content_btns {
        position: absolute;
        top: 0;
        right: 10px;

        &>.v-btn {
          min-width: 50px;
          padding: 0 16px !important;
          margin: 0 !important;

          &:nth-child(n + 2) {
            &::after {
              content: "";
              position: absolute;
              height: 50%;
              border-right: 1px solid rgba(196, 196, 196, .5);
              left: 0;
              top: 50%;
              transform: translateY(-50%);
            }
          }
        }
      }
    }
  }
}
</style>